var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import Butter from 'buttercms';
import { RouterProvider, createBrowserRouter } from 'react-router';
import ErrorBoundary from './404';
import Accessibility from './accessibility/page';
import Affiliate from './affiliate/page';
import { getApiKey } from './api/butter';
import ArticleRoutes from './blog/page';
import Careers from './careers/page';
import FAQ from './faq/page';
import Home from './home/page';
import HowItWorks from './how-it-works/page';
import RootLayout from './layout';
import MealsRoutes from './meals/page';
import MessagingTerms from './messaging-terms/page';
import OptOut from './opt-out/page';
import OtherProductsRoutes from './other-products/page';
import Press from './press/page';
import ProfileRoutes from './profile/page';
import Retail from './retail/page';
import './tailwind.css';
import Team from './team/page';
import TermsOfService from './tos/page';
import VetPage from './vet/page';
import WhyNomNom from './why-nom-nom/page';
var routes = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
    {
        path: 'accessibility',
        element: _jsx(Accessibility, {}),
    },
    { path: 'affiliate', element: _jsx(Affiliate, {}) }
], ArticleRoutes, true), [
    { path: 'careers', element: _jsx(Careers, {}) },
    { path: 'faq', element: _jsx(FAQ, {}) },
    { path: 'how-it-works', element: _jsx(HowItWorks, {}) }
], false), MealsRoutes, true), [
    { path: 'messaging-terms', element: _jsx(MessagingTerms, {}) },
    { path: 'opt-out', element: _jsx(OptOut, {}) }
], false), OtherProductsRoutes, true), [
    { path: 'press', element: _jsx(Press, {}) },
    { path: 'retail', element: _jsx(Retail, {}) },
    { path: 'team', element: _jsx(Team, {}) },
    { path: 'tos', element: _jsx(TermsOfService, {}) },
    {
        path: 'why-nom-nom',
        element: _jsx(WhyNomNom, {}),
    },
    { path: 'vet', element: _jsx(VetPage, {}) },
    { index: true, element: _jsx(Home, {}) },
], false);
var router = createBrowserRouter([
    {
        path: '/',
        id: 'root',
        loader: function () { return __awaiter(void 0, void 0, void 0, function () {
            var apiKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getApiKey()];
                    case 1:
                        apiKey = (_a.sent()).data.blogApiKey;
                        return [2 /*return*/, { Butter: Butter(apiKey) }];
                }
            });
        }); },
        children: __spreadArray(__spreadArray([
            {
                element: _jsx(RootLayout, {}),
                children: routes,
            }
        ], ProfileRoutes, true), [
            { path: '*', element: _jsx(ErrorBoundary, {}) },
        ], false),
        errorElement: _jsx(ErrorBoundary, {}),
    },
]);
var MarketingSiteApp = function () {
    return _jsx(RouterProvider, { router: router });
};
export default MarketingSiteApp;
